import { Expose } from "class-transformer";
import { safeAssign } from "./safe-assign";
import { NoteType } from "../../model";

export class NoteDTO {
    @Expose()
    content: string;

    @Expose()
    type: NoteType;

    constructor(props: NoteDTO) {
        safeAssign<NoteDTO>(this, props);
    }
}
